import React from 'react';
import { useLocation } from 'react-router-dom';
import useUnitLinks from '../hooks/useUnitLinks';
import { Awa300x600Content } from './components/Awa300x600Content';
import { Awa728x90Content } from './components/Awa728x90Content';
import { BottomSectionContent } from './components/BottomSectionContent';
import { Divider } from './components/Divider';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { InAdContent } from './components/InAdContent';
import './index.scss';

export const Revue = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const unitLinks = useUnitLinks({ searchParams });

    return (
        <div className='module-1'>
            <Header />
            <InAdContent src={unitLinks.inAd} />
            <Divider />
            <Awa300x600Content src={unitLinks['300x600']} />
            <Awa728x90Content src={unitLinks['728x90']} />
            <BottomSectionContent />
            <Footer />
        </div>
    );
};
